import React from 'react';
import useCarousel from '@stencil/use-carousel';
import SeoSrpCarouselUi from '@stencil/dstories/src/components/SRP/Offers/seo-srp-carousel-ui';

const SeoSrpCarousel = props => {
  const { offers } = props;

  if (!offers || offers.length < 1) {
    return null;
  }

  const { dataList, increment, decrement, isLeftCursorActive, isRightCursorActive } = useCarousel(
    offers,
    1
  );

  const onOfferClickHandler = (url: string) => {
    window.open(url);
  };

  return (
    <SeoSrpCarouselUi
      offer={dataList[0]}
      onClickHandler={onOfferClickHandler}
      handleNextClick={increment}
      handlePrevClick={decrement}
      isLeftCursorActive={isLeftCursorActive}
      isRightCursorActive={isRightCursorActive}
    />
  );
};

export default SeoSrpCarousel;
